import { render, staticRenderFns } from "./modulos.vue?vue&type=template&id=6d0f79d3&scoped=true"
import script from "./modulos.vue?vue&type=script&lang=js"
export * from "./modulos.vue?vue&type=script&lang=js"
import style0 from "./modulos.vue?vue&type=style&index=0&id=6d0f79d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0f79d3",
  null
  
)

export default component.exports